module.exports = __webpack_public_path__ + "static/media/phone.03b43118.svg";